import { fetcher } from '@commenda/utils';

const deletePolicy = async (id: string) => {
  const res = await fetcher(`transfer-pricing/policy/${id}`, {
    method: 'DELETE',
  });
  return res;
};

export default deletePolicy;
